import LiquidacionAgenciaPage from "./LiquidacionAgenciaPage";

export {LiquidacionAgenciaPage}
export default LiquidacionAgenciaPage
